AFRAME.registerComponent('sectors-control', {
    schema: {
        sectorsBreaks: { type: 'boolean', default: true },
        sectorsDepth: { type: 'number', default: 6 },
        activeSectorIDs: { type: 'array', default: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },

    },

    init: function () {
        this.itemWidth = 0.56
        this.itemHeight = 0.06
        this.itemSpacing = 0.01;
        this.padding = 0.02;
        this.mainLabelFontSize = 0.02;

        this.content = this.el.querySelector('#sectors-control-content')
        this.raycasterPlane = this.el.querySelector('.raycaster-plane')

        this.themeMode = 'Dark';
        const mainSettings = getCacheItem('mainSettings');
        if (mainSettings && mainSettings.themeMode) {
            this.themeMode = mainSettings.themeMode;
        }

        window.addEventListener('theme-changed', (e) => {
            if (e.detail && e.detail.themeMode) {
                this.themeMode = e.detail.themeMode;
                this.applySettings();
                this.createHeader();
                this.createContent();
            }
        });

        this._initVariables();
        this.applySettings();

        this.loadState();

        this.createHeader()
        this.createContent()

        if (window.PopupManager) {
            window.PopupManager.register('sectors-control', this.el);
        }

        this.el.addEventListener('load-sector-state', (evt) => {
            this.loadState(evt.detail && evt.detail.action);
        });

        this._isMmapLocked = false;
        this.el.sceneEl.addEventListener('chart-type-changed', (e) => {
            const action = e.detail && e.detail.action;
            if (action === 'mmap') {
                const mode = (typeof getCacheItem === 'function' ? getCacheItem('mmap_view_mode') : null) || '2d';
                this._setMmapLocked(mode === '3d');
            } else {
                this._setMmapLocked(false);
            }
        });
        this.el.sceneEl.addEventListener('mmap-mode-changed', (e) => {
            const mode = (e.detail && e.detail.mode) || '2d';
            const chartControlEl = document.querySelector('[chart-type-control]');
            const action = chartControlEl?.getAttribute('chart-type-control')?.selectedPrimeAction;
            if (action === 'mmap') {
                this._setMmapLocked(mode === '3d');
            }
        });

        setTimeout(() => {
            const chartControlEl = document.querySelector('[chart-type-control]');
            const action = chartControlEl?.getAttribute('chart-type-control')?.selectedPrimeAction;
            if (action === 'mmap') {
                const mode = (typeof getCacheItem === 'function' ? getCacheItem('mmap_view_mode') : null) || '2d';
                this._setMmapLocked(mode === '3d');
            }
        }, 300);

        const targetNode = document.getElementById('large-center-panel-content') || this.el.sceneEl || document.body;
        if (targetNode) {
            this._cubeObserver = new MutationObserver((mutations) => {
                for (let mutation of mutations) {
                    if (mutation.addedNodes.length > 0) {
                        for (let node of mutation.addedNodes) {
                            if (node.id === 'stock-3d-cube' || (node.querySelector && node.querySelector('#stock-3d-cube'))) {
                                setTimeout(() => this.applyToCube(), 50);
                            }
                        }
                    }
                }
            });
            this._cubeObserver.observe(targetNode, { childList: true, subtree: true });
        }
    },

    _setMmapLocked: function (locked) {
        this._isMmapLocked = locked;
        if (locked && !this.data.sectorsBreaks) {
            this.el.setAttribute('sectors-control', 'sectorsBreaks', true);
        }
        this.content.innerHTML = '';
        this.createSectorsBreaksRow();
        if (this.data.sectorsBreaks) {
            this.createSectorsContent();
        }
    },

    loadState: function(action) {
        try {
            let primeAction = action;
            if (!primeAction) {
                const chartTypeControl = document.querySelector('#top-menu-container');
                primeAction = chartTypeControl ? chartTypeControl.getAttribute('chart-type-control').selectedPrimeAction : 'topdollar';
            }
            
            if (primeAction === 'watchlist-reports' || primeAction === 'mmap') return null;

            const key = `segments_state_${primeAction}`;
            const cached = typeof getCacheItem !== 'undefined' ? getCacheItem(key) : null;
            
            let state;
            if (cached) {
                state = JSON.parse(cached);
            } else {
                state = {
                    sectorsBreaks: true,
                    sectorsDepth: 6,
                    activeSectorIDs: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
                };
            }

            this._isInternalLoading = true;
            this.el.setAttribute('sectors-control', {
                sectorsBreaks: state.sectorsBreaks,
                sectorsDepth: state.sectorsDepth,
                activeSectorIDs: state.activeSectorIDs
            });
            this._isInternalLoading = false;

            return state;
        } catch (e) {
            console.warn('[SectorsControl] Failed to load state', e);
            return null;
        }
    },

    saveState: function() {
        try {
            const chartTypeControl = document.querySelector('#top-menu-container');
            const primeAction = chartTypeControl ? chartTypeControl.getAttribute('chart-type-control').selectedPrimeAction : 'topdollar';
            
            if (primeAction === 'watchlist-reports' || primeAction === 'mmap') return;

            const state = {
                sectorsBreaks: this.data.sectorsBreaks,
                sectorsDepth: this.data.sectorsDepth,
                activeSectorIDs: this.data.activeSectorIDs
            };
            
            const key = `segments_state_${primeAction}`;
            if (typeof setCacheItem !== 'undefined') {
                const expiration = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;
                setCacheItem(key, JSON.stringify(state), expiration);
            }
        } catch (e) {
            console.warn('[SectorsControl] Failed to save state', e);
        }
    },

    _initVariables: function () {
        this.bgPlaneDark = this.el.querySelector('.background-panel-dark');
        this.bgPlaneLight = this.el.querySelector('.background-panel-light');
        this.bgPlanes = [this.bgPlaneDark, this.bgPlaneLight].filter(el => el);
    },

    applySettings: function () {
        const isLight = this.themeMode === 'Light';
        if (this.bgPlaneDark) this.bgPlaneDark.setAttribute('visible', !isLight);
        if (this.bgPlaneLight) this.bgPlaneLight.setAttribute('visible', isLight);
    },


    createHeader: function () {
        this.el.querySelectorAll('.header-element').forEach(el => el.parentNode.removeChild(el));

        const isLight = this.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        // main text
        const title = document.createElement('a-troika-text');
        title.classList.add('header-element');
        title.setAttribute('value', 'Sectors');
        title.setAttribute('font-size', 0.03);
        title.setAttribute('color', txtColor);
        title.setAttribute('anchor', 'center');
        title.setAttribute('position', `0 0.43 0.01`)
        this.el.appendChild(title);

        const cross = document.createElement('a-troika-text');
        cross.classList.add('header-element');
        cross.setAttribute('value', '×');
        cross.setAttribute('font-size', 0.04);
        cross.setAttribute('color', txtColor);
        cross.setAttribute('anchor', 'center');
        cross.setAttribute('position', `0.26 0.43 0.01`)
        this.el.appendChild(cross);

        let interactivePlane = this.el.querySelector('#close-sectors-popup');
        if (!interactivePlane) {
            interactivePlane = document.createElement('a-plane');
            interactivePlane.setAttribute('id', 'close-sectors-popup');
            interactivePlane.setAttribute('height', 0.04);
            interactivePlane.setAttribute('width', 0.04);
            interactivePlane.setAttribute('position', `0.26 0.43 0.01`);
            interactivePlane.setAttribute('opacity', '0');
            interactivePlane.setAttribute('data-raycastable', '');
            interactivePlane.addEventListener('click', () => {
                if (window.PopupManager) {
                    window.PopupManager.close('sectors-control');
                } else {
                    this.el.setAttribute('visible', false);
                }
            });
            this.el.appendChild(interactivePlane);
        }
    },

    createContent: function () {
        this.createSectorsBreaksRow()
        this.createSectorsContent()
    },

    createSectorsBreaksRow: function () {
        const row = document.createElement('a-entity');
        const isLight = this.themeMode === 'Light';
        const locked = this._isMmapLocked;
        const txtColor = locked ? '#666666' : (isLight ? '#14141C' : '#FFFFFF');

        const interactivePlane = document.createElement('a-plane');
        interactivePlane.setAttribute('height', 0.06);
        interactivePlane.setAttribute('width', 0.56);
        interactivePlane.setAttribute('position', `${this.itemWidth / 2} 0 0.0005`);
        interactivePlane.setAttribute('opacity', '0');
        if (!locked) {
            interactivePlane.setAttribute('data-raycastable', '');
            interactivePlane.addEventListener('click', () => {
                this.el.setAttribute('sectors-control', 'sectorsBreaks', !this.data.sectorsBreaks);

                if (window.gtag) gtag('event', `VR_CenterPanel_Sectors `, { mode: this.data.sectorsBreaks ? 'sector' : 'non-sector' });
            });
        }
        row.appendChild(interactivePlane);

        const text = document.createElement('a-troika-text');
        text.setAttribute('value', 'Sectors breaks');
        text.setAttribute('font-size', this.mainLabelFontSize);
        text.setAttribute('color', txtColor);
        text.setAttribute('anchor', 'left');
        text.setAttribute('position', `${this.padding} 0 0.001`)
        row.appendChild(text);

        const switcher = document.createElement('a-image');
        switcher.setAttribute('src', this.data.sectorsBreaks ? '#checkbox-active-icon' : '#checkbox-inactive-icon');
        switcher.setAttribute('width', this.itemHeight * 0.75);
        switcher.setAttribute('height', this.itemHeight * 0.75);
        switcher.setAttribute('position', `0.53 0 0.001`);
        if (locked) switcher.setAttribute('opacity', '0.35');
        row.appendChild(switcher);

        row.setAttribute('position', `${-this.itemWidth / 2} ${- this.itemHeight / 2} 0.001`)
        this.content.appendChild(row);

    },
    createSectorsContent: function () {
        this.createSectorDepthRow()

        const segmentsList = [
            { id: 1, name: 'Utilities', iconName: '#utilities-icon', color: '#00C4B3' },
            { id: 2, name: 'Energy', iconName: '#energy-icon', color: '#ACACAC' },
            { id: 3, name: 'Materials', iconName: '#materials-icon', color: '#697AB6', },
            { id: 4, name: 'Financials', iconName: '#financials-icon', color: '#C8C8C8' },
            { id: 5, name: 'Health Care', iconName: '#health-care-icon', color: '#E54360', },
            { id: 6, name: 'Real Estate', iconName: '#real-estate-icon', color: '#CAD1EA', },
            { id: 7, name: 'Information Technology', iconName: '#information-technology-icon', color: '#00945E' },
            { id: 8, name: 'Industrials', iconName: '#industrials-icon', color: '#3636E3', },
            { id: 9, name: 'Communication Services', iconName: '#communication-services-icon', color: '#697AB6', },
            { id: 10, name: 'Consumer Staples', iconName: '#consumer-staples-icon', color: '#F18A00', },
            { id: 11, name: 'Consumer Discretionary', iconName: '#customer-discretionary-icon', color: '#FFC629', },
        ]
        segmentsList.forEach((item, index) => {
            const pY = -(this.itemHeight + this.itemSpacing) * (index + 2) - this.itemSpacing - this.itemHeight / 2;
            this.createSegmentRow(item, pY)
        })
    },

    createSectorDepthRow: function () {
        const row = document.createElement('a-entity');
        const isLight = this.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const itemBgColor = isLight ? '#000' : '#fff';
        const itemBgOpacity = isLight ? '0.05' : '0.1';

        const text = document.createElement('a-troika-text');
        text.setAttribute('value', 'Sectors depth');
        text.setAttribute('font-size', this.mainLabelFontSize);
        text.setAttribute('color', txtColor);
        text.setAttribute('anchor', 'left');
        text.setAttribute('position', `${this.padding} 0 0.001`)
        row.appendChild(text);


        const numberContainer = document.createElement('a-entity');
        const numberBg = document.createElement('a-rounded-plane');
        numberBg.setAttribute('height', this.itemHeight * 0.75);
        numberBg.setAttribute('width', this.itemHeight * 0.75);
        numberBg.setAttribute('radius', '0.005');
        numberBg.setAttribute('color', itemBgColor);
        numberBg.setAttribute('opacity', itemBgOpacity);
        numberBg.setAttribute('position', `${-this.itemHeight * 0.5 * 0.75} ${-this.itemHeight * 0.5 * 0.75} 0`);
        numberContainer.appendChild(numberBg);

        const numberValue = document.createElement('a-troika-text');
        numberValue.setAttribute('value', this.data.sectorsDepth);
        numberValue.setAttribute('font-size', this.mainLabelFontSize);
        numberValue.setAttribute('color', txtColor);
        numberValue.setAttribute('anchor', 'center');
        numberValue.setAttribute('position', `0 0 0.0001`)
        numberContainer.appendChild(numberValue);
        numberContainer.setAttribute('position', `0.41 0 0.001`)
        row.appendChild(numberContainer);


        const arrowUp = document.createElement('a-image');
        arrowUp.setAttribute('src', '#arrow-up-icon');
        arrowUp.setAttribute('width', this.itemHeight * 0.75);
        arrowUp.setAttribute('height', this.itemHeight * 0.75);
        arrowUp.setAttribute('position', `0.47 0 0.001`)

        row.appendChild(arrowUp);
        const arrowDown = document.createElement('a-image');
        arrowDown.setAttribute('src', '#arrow-down-icon');
        arrowDown.setAttribute('width', this.itemHeight * 0.75);
        arrowDown.setAttribute('height', this.itemHeight * 0.75);
        arrowDown.setAttribute('position', `0.53 0 0.001`)
        row.appendChild(arrowDown);

        const interactivePlane1 = document.createElement('a-plane');
        interactivePlane1.setAttribute('height', this.itemHeight * 0.75);
        interactivePlane1.setAttribute('width', this.itemHeight * 0.75);
        interactivePlane1.setAttribute('opacity', '0.5');
        interactivePlane1.setAttribute('data-raycastable', '');
        const interactivePlane2 = interactivePlane1.cloneNode();
        interactivePlane1.setAttribute('position', `0.47 0 0.0005`);
        interactivePlane2.setAttribute('position', `0.53 0 0.0005`);
        interactivePlane1.addEventListener('click', () => {
            if (this.data.sectorsDepth < 10) this.el.setAttribute('sectors-control', 'sectorsDepth', this.data.sectorsDepth + 1);
        })
        interactivePlane2.addEventListener('click', () => {
            if (this.data.sectorsDepth > 1) this.el.setAttribute('sectors-control', 'sectorsDepth', this.data.sectorsDepth - 1);
        })
        row.appendChild(interactivePlane1);
        row.appendChild(interactivePlane2);



        row.setAttribute('position', `${-this.itemWidth / 2} ${-this.itemSpacing - this.itemHeight * 1.5} 0`)
        this.content.appendChild(row);
    },
    createSegmentRow: function (item, pY) {
        const row = document.createElement('a-entity');
        const isLight = this.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const itemBgColor = isLight ? '#000' : '#fff';
        const itemBgOpacity = isLight ? '0.05' : '0.02';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('height', this.itemHeight);
        bg.setAttribute('width', this.itemWidth);
        bg.setAttribute('radius', '0.01');
        bg.setAttribute('color', itemBgColor);
        bg.setAttribute('opacity', itemBgOpacity);
        bg.setAttribute('position', `0 ${-this.itemHeight / 2} 0.001`);
        row.appendChild(bg);

        const dot = document.createElement('a-circle');
        dot.setAttribute('radius', this.itemHeight * 0.15);
        dot.setAttribute('color', item.color);
        dot.setAttribute('position', `${this.padding + this.itemHeight * 0.08} 0 0.002`);
        row.appendChild(dot)

        const icon = document.createElement('a-image');
        icon.setAttribute('src', item.iconName);
        icon.setAttribute('width', this.itemHeight * 0.75);
        icon.setAttribute('height', this.itemHeight * 0.75);
        icon.setAttribute('position', `0.06 0 0.002`)
        row.appendChild(icon);

        const text = document.createElement('a-troika-text');
        text.setAttribute('value', item.name);
        text.setAttribute('font-size', this.mainLabelFontSize);
        text.setAttribute('color', txtColor);
        text.setAttribute('anchor', 'left');
        text.setAttribute('position', `0.09 0 0.002`)
        row.appendChild(text)

        const switcher = document.createElement('a-image');
        const isActive = this.data.activeSectorIDs && this.data.activeSectorIDs.includes(item.id);
        switcher.setAttribute('src', isActive ? '#checkbox-active-icon' : '#checkbox-inactive-icon');
        switcher.setAttribute('width', this.itemHeight * 0.75);
        switcher.setAttribute('height', this.itemHeight * 0.75);
        switcher.setAttribute('position', `0.53 0 0.002`)
        row.appendChild(switcher);

        const interactivePlane = document.createElement('a-plane');
        interactivePlane.setAttribute('height', this.itemHeight);
        interactivePlane.setAttribute('width', this.itemWidth)
        interactivePlane.setAttribute('position', `${this.itemWidth / 2} 0 0.0005`);
        interactivePlane.setAttribute('opacity', '0');
        interactivePlane.setAttribute('data-raycastable', '');
        interactivePlane.addEventListener('click', () => {
            const activeSectorIDsTemp = [...this.data.activeSectorIDs]
            const index = activeSectorIDsTemp.indexOf(item.id);
            if (index !== -1) {
                activeSectorIDsTemp.splice(index, 1);
            } else {
                activeSectorIDsTemp.push(item.id);
            }
            this.el.setAttribute('sectors-control', 'activeSectorIDs', activeSectorIDsTemp);

        })
        row.appendChild(interactivePlane);

        row.setAttribute('position', `${-this.itemWidth / 2} ${pY} 0`)
        this.content.appendChild(row);
    },

    update: function (oldData) {
        const self = this
        this.content.innerHTML = '';
        this.createSectorsBreaksRow()
        console.log('this.data', this.data)

        if (oldData.sectorsBreaks !== this.data.sectorsBreaks) {
            if (this.data.sectorsBreaks) {

                this.bgPlanes.forEach(plane => {
                    plane.setAttribute('animation__height', {
                        property: 'height',
                        to: 1.01,
                        dur: 200,
                        easing: 'linear'
                    });
                    plane.addEventListener('animationcomplete__height', onGrowBgAnimationFinished)
                    function onGrowBgAnimationFinished() {
                        self.raycasterPlane.setAttribute('height', 1.01);
                        self.raycasterPlane.setAttribute('position', '0 -0.02 0');
                        self.createSectorsContent()
                        plane.removeEventListener('animationcomplete__height', onGrowBgAnimationFinished)
                    }
                });
            } else {
                this.raycasterPlane.setAttribute('height', 0.16);
                this.raycasterPlane.setAttribute('position', '0 0.4 0');

                this.bgPlanes.forEach(plane => {
                    plane.setAttribute('animation__height', {
                        property: 'height',
                        to: 0.16,
                        dur: 200,
                        easing: 'linear'
                    });
                });
            }
            if (!this._isInternalLoading) {
                const primeTypeButton = document.querySelector('#top-menu-container')
                if (primeTypeButton) {
                    primeTypeButton.emit('change-secondary-action', { isActive: this.data.sectorsBreaks });
                } else {
                    console.warn('Element #top-menu-container not found');
                }
            }

        } else {
            if (this.data.sectorsBreaks) {
                this.createSectorsContent()
            }
        }

        if (oldData.sectorsDepth !== this.data.sectorsDepth ||
            oldData.activeSectorIDs !== this.data.activeSectorIDs) {
            const stock3dCube = document.querySelector('a-scene#main-scene #stock-3d-cube') || document.querySelector('#stock-3d-cube');
            if (stock3dCube) {
                const doUpdate = () => setTimeout(() => {
                    stock3dCube.setAttribute('stock-cube-visualizer', {
                        sectorIds: this.data.activeSectorIDs,
                        topN: this.data.sectorsDepth
                    });
                }, 50);

                if (stock3dCube.hasLoaded) {
                    doUpdate();
                } else {
                    doUpdate();
                    stock3dCube.addEventListener('loaded', doUpdate, { once: true });
                }
            }
        }

        if (Object.keys(oldData).length > 0 && !this._isInternalLoading) {
            this.saveState();
        }

        this.applyToCube();
    },

    applyToCube: function() {
        if (!this.data.sectorsBreaks) return;

        const cube = document.querySelector('#stock-3d-cube') || document.querySelector('a-scene#main-scene #stock-3d-cube');
        if (cube) {
            const doUpdate = () => setTimeout(() => {
                cube.setAttribute('stock-cube-visualizer', {
                    topN: this.data.sectorsDepth,
                    sectorIds: this.data.activeSectorIDs
                });
            }, 50);

            if (cube.hasLoaded) {
                doUpdate();
            } else {
                doUpdate();
                cube.addEventListener('loaded', doUpdate, { once: true });
            }
        } else {
            console.warn('[SectorsControl] applyToCube: Cube element #stock-3d-cube not found');
        }
    }
})
